import React from 'react';

import './hamburger-menu.scss';
import clsx from 'clsx';

/**
 * Describe component here
 * @param props
 */
const HamburgerMenu = ({ isActive, onMenuClick }) => {

  return <div className={'hamburger-menu'}>
    <button className={clsx('hamburger-menu__button', { 'hamburger-menu__button--is-active': isActive })} onClick={() => onMenuClick(!isActive)}>
      <div className="hamburger-menu__bar"></div>
    </button>
  </div>;
};

export default HamburgerMenu;
